import { render, staticRenderFns } from "./errorReportModal.vue?vue&type=template&id=2d4e9ef6&scoped=true&"
import script from "./errorReportModal.vue?vue&type=script&lang=js&"
export * from "./errorReportModal.vue?vue&type=script&lang=js&"
import style0 from "./errorReportModal.vue?vue&type=style&index=0&id=2d4e9ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e9ef6",
  null
  
)

export default component.exports